import { z } from 'zod'
import type { TwoFactorBackupCodes } from '../../models/TwoFactorBackupCodes'

export const TwoFactorBackupCodeItemDTO = z.object({
  code: z.string(),
  used: z.boolean()
})

export const TwoFactorRevealedBackupCodesDTO = z.object({
  backup_codes: z.array(TwoFactorBackupCodeItemDTO).min(1)
})

export type TwoFactorRevealedBackupCodesDTO = z.infer<typeof TwoFactorRevealedBackupCodesDTO>

export function mapDTOToTwoFactorRevealedBackupCodes (dto: TwoFactorRevealedBackupCodesDTO): TwoFactorBackupCodes {
  return {
    items: dto.backup_codes.map(item => ({
      code: item.code,
      used: item.used
    }))
  }
}
